module.exports = __webpack_public_path__ + "static/media/gold.efd38a50.png";